import { FC, ReactNode, useEffect } from "react";
import {
  CHECK_GEOLOCATION_MAXIMUM_AGE,
  CHECK_GEOLOCATION_TIMEOUT,
  usePostApiGeolocationMutation,
} from "..";

interface GeolocationProviderProps {
  children: ReactNode;
}

export const GeolocationProvider: FC<GeolocationProviderProps> = (props) => {
  const { children } = props;
  const [sendGeolocation] = usePostApiGeolocationMutation();

  const sendLocation = async (lat: number, lon: number) => {
    try {
      await sendGeolocation({
        applicationGeolocation: { latitude: lat, longitude: lon },
      });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!("geolocation" in navigator)) {
      console.error("Geolocation is not supported by this browser.");
      return;
    }

    const watchId = navigator.geolocation.watchPosition(
      (position) =>
        sendLocation(position.coords.latitude, position.coords.longitude),
      (error) => console.error("Error getting location:", error),
      {
        enableHighAccuracy: true,
        timeout: CHECK_GEOLOCATION_TIMEOUT,
        maximumAge: CHECK_GEOLOCATION_MAXIMUM_AGE,
      }
    );

    return () => {
      navigator.geolocation.clearWatch(watchId);
    };
  }, []);

  return <>{children}</>;
};
